<template>
  <v-footer dark padless>
    <v-container tag="ul" class="footer__list caption">
      <li>© Olympus {{ new Date().getFullYear() }}</li>
      <li v-for="item in footerUrls" :key="item.url">
        <a v-bind="getFooterLinkProps(item)">
          {{ item.label }}
        </a>
      </li>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',

  computed: {
    footerUrls() {
      return [
        {
          label: this.$t('footer.imprint.label'),
          url: this.$t('footer.imprint.url')
        },
        {
          label: this.$t('footer.termsOfUse.label'),
          url: this.$t('footer.termsOfUse.url')
        },
        {
          label: this.$t('footer.privacyNotice.label'),
          url: this.$t('footer.privacyNotice.url')
        },
        {
          label: this.$t('footer.cookies.label'),
          url: this.$t('footer.cookies.url')
        },
        {
          label: this.$t('footer.cookiesSettings.label'),
          class: 'ot-sdk-show-settings'
        },
        {
          label: this.$t('footer.socialMedia.label'),
          url: this.$t('footer.socialMedia.url')
        }
      ];
    }
  },
  methods: {
    getFooterLinkProps(item) {
      return {
        class: `footer__link${item.class ? ` ${item.class}` : ''}`,
        ...(item.url ? { href: item.url, target: '_blank' } : {})
      };
    }
  }
};
</script>

<style scoped lang="scss">
.footer__link {
  text-decoration: none;
  color: var(--v-grey-footer-link-base);

  &:hover {
    color: var(--v-secondary-base);
  }
}

.footer__list {
  list-style-type: none;

  > li {
    display: inline-block;
    padding: 0.5rem;
  }
}
</style>
